import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';
import { StyleService } from 'app/infrastructure/services/style.service';
import { ItemCarousel } from '../../model/ItemCarousel';
import { EntityOperationModel } from '../../model/EntityOperationModel';
import { Router, ActivatedRoute } from '@angular/router';
import { EntityAction } from '../../model/EntityActions';

@Component({
  selector: 'entity-operations',
  templateUrl: './entity-operations.component.html'
})
export class EntityOperationsComponent implements OnInit, OnDestroy {

  get carouselItemList(): EntityOperationModel {
    // transform value for display

    return this._carouselItemList;
  }

  @Input('carouselItemList') set carouselItemList(operation: EntityOperationModel) {
    this._carouselItemList = operation;
  }

  private _carouselItemList: EntityOperationModel;
  public carouselTileItems: ItemCarousel[];
  public carouselTile: NgxCarousel;
  public carouselTitle: String;

  constructor(private styleService: StyleService,
    private router: Router,
    private aRoute: ActivatedRoute) { }

  ngOnInit() {
    this.styleService.addStyle('EntityOperationsComponent', require('./entity-operations.component.css'));

    this.carouselTile = {
      grid: { xs: 2, sm: 3, md: 3, lg: 3, all: 0 },
      slide: 2,
      speed: 400,
      animation: 'lazy',
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      easing: 'ease',
      loop: true
    }
  }

  filteredCarousel(): EntityAction[] {
    return this.carouselItemList.itemCarousel.filter(x => x.description != 'EDITAR');
  }
  
  goTo(route: string) {
    if (route !== null)
      this.router.navigate(["." + route], { relativeTo: this.aRoute });
  }

  ngOnDestroy(){
    this.styleService.removeStyle('EntityOperationsComponent');
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityWithChilds/main-entity-component/entity-operations/entity-operations.component.ts